// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"f9f13195","196":"9283f6e3","379":"b9de71a3","453":"624b2211","497":"38a00011"}[chunkId] + ".chunk.js";
};